import { useEffect, useState } from 'react';
import { LoadingService } from '../../helpers/loading';

import { ProgressSpinner } from 'primereact/progressspinner';
        
const LoadingSpinner = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    return LoadingService.subscribe(setIsLoading);
  }, []);

  if (!isLoading) return null;

  return (
    <div className='keduall-loading-container animate__animated animate__fadeIn animate__delay-2s'>
      <ProgressSpinner />
    </div>
  );
};

export default LoadingSpinner;